import React, { Component } from 'react';

import { Card, Row, Col } from 'react-bootstrap';

import * as Constants from '../../../constants/constants';
import GetPdf from '../get-pdf';
import i18n from "../../../i18n";
import "./s-doc-info.css"

const titleStyle = {
    backgroundColor: Constants.MAIN_COLOR,
    color: "#fff",
    fontWeight: "bold",
    fontSize: "18px"
}

const marginRemove = {
    marginLeft: "0px",
    marginRight: "0px"
}

const padding = {
    padding: "15px"
}

const indicationCenter = {
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    fontWeight: "bold",
    paddingTop: "30px",
    paddingBottom: "30px",

}

const atrwithValue = "col-lg-6 col-sm-12 col-12 border"
const atrOrValue = "col-lg-6 col-sm-6 col-6"
const sigClass = "col-lg-2 col-sm-12 col-12 border"

export default class DocumentInformation extends Component {

    constructor(props) {
        super(props);
      
        this.triggerChildGetPdf = this.triggerChildGetPdf.bind(this);
    }

    triggerChildGetPdf() {
        this.refs.simpleChild.handleDownload(0, this.props.language);
    }
   
    render() {

        return (
            <React.Fragment>

                <Card.Header style={titleStyle} >
                    {i18n.t("docInfo:document_information")}
                </Card.Header>

                <Row style={marginRemove}>
                    <Col style={padding} className="col-lg-12 col-sm-12 col-12 border">
                        <Row>
                            <Col className="col-lg-3 col-sm-6 col-6">{i18n.t("docInfo:document_name")}</Col>
                            <Col className="col-lg-9 col-sm-6 col-6" style={{ "wordWrap": "break-word" }}> {this.props.documentName}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row style={marginRemove}>
                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_generation_time")}</Col>
                            <Col className={atrOrValue} >{this.props.reportGenerationTime}</Col>
                        </Row>
                    </Col>

                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:num_of_signatures")}</Col>
                            <Col className={atrOrValue} >{this.props.signaturesCount}</Col>
                        </Row>
                    </Col>
                </Row>

                <Row style={marginRemove}>
                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_avalible_on")}</Col>
                            <Col className={atrOrValue} >
                                <div onClick={() => this.triggerChildGetPdf()}>
                                    <GetPdf ref="simpleChild" hash={this.props.hash} linkId={this.props.linkId} documentName={this.props.documentName} reportType={1} button={true}/>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col style={padding} className={atrwithValue}>
                        <Row>
                            <Col className={atrOrValue} >{i18n.t("docInfo:report_avalible_until")}</Col>
                            <Col className={atrOrValue} >{this.props.permLinkValidUntil}</Col>
                        </Row>
                    </Col>
                </Row>

                {this.props.signaturesCount > 0 ?
                    <Row className="border margin-remove">

                        <Col className="col-lg-2 col-12 border-bottom sdi-padding">
                            {this.props.signaturesCount > 1 ?
                                <span>
                                    {i18n.t("docInfo:signatures_status")}
                                </span>
                                :
                                <span>
                                    {i18n.t("docInfo:signature_status")}
                                </span>
                            }
                        </Col>
                        <Col className="col-lg-10 col-12 border-left padding-remove">
                            {this.props.signature.map((signature, i) => {
                                  console.log("signature.indication")
                                  console.log(signature.indication)
                                return <Row key={i} className="margin-remove border-bottom">
                                    <Col className="col-lg-1 col-2 text-center align-self-center sdi-padding font-weight-bold">
                                        {i + 1}.
                                    </Col>

                                    <Col className="col-lg-8 col-10 border-left sdi-padding font-weight-bold">
                                        <span>
                                            {signature.signedBy}
                                        </span>
                                        <br />
                                        <span className="sig-id">
                                            {signature.id}
                                        </span>
                                    </Col>
                                    <Col className="d-lg-none col-2 border-top" style={{ backgroundColor: indicationColor(signature.indication) }}> </Col>
                                    <Col className="col-lg-3 col-10 sig-indi sdi-padding font-weight-bold" style={{ backgroundColor: indicationColor(signature.indication) }}>
                                        <span>
                                          
                                            {i18n.t("simple:" + signature.indication)}
                                        </span>
                                    </Col>
                                </Row>
                            })}
                        </Col>
                    </Row>
                    :
                    null
                }
            </React.Fragment>
        )
    }
}

function indicationColor(tIndication) {
    if (tIndication == "TOTAL_PASSED" || tIndication == "PASSED") {
        return Constants.GREEN;
    } else if (tIndication == "INDETERMINATE") {
        return Constants.ORANGE;
    } else if (tIndication == "TOTAL_FAILED" || tIndication == "FAILED") {
        return Constants.RED;
    }
    return Constants.WHITE;
}